
import * as avoidConst from './constants';

export default {
    [avoidConst.getAvoids](state, list) {
        state.list = list.DataGuardsSet;
    }
};
